var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox lucky-wheel-operate" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.detailLoading,
              expression: "detailLoading",
            },
          ],
          staticClass: "box-card",
          attrs: { shadow: "never" },
        },
        [
          _c(
            "el-steps",
            {
              staticClass: "operate-steps",
              attrs: {
                active: _vm.currentStep,
                "align-center": "",
                "finish-status": "success",
              },
            },
            [
              _c("el-step", { attrs: { title: "新建活动" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: "配置规则" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "step-title" }, [
            _vm._v(
              _vm._s(
                _vm.currentStep === 0 ? "第一步：新建活动" : "第二步：配置规则"
              )
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "baseForm",
              staticClass: "operate-form",
              attrs: {
                model: _vm.formData,
                rules: _vm.formRules,
                "label-width": "140px",
                size: "small",
                disabled: _vm.isView,
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === 0,
                      expression: "currentStep === 0",
                    },
                  ],
                  staticClass: "step-panel step-panel-form",
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "活动名称", prop: "activityName" } },
                    [
                      _c("el-input", {
                        staticClass: "w-360 name-input",
                        attrs: {
                          maxlength: "50",
                          "show-word-limit": "",
                          placeholder: "请输入",
                        },
                        model: {
                          value: _vm.formData.activityName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "activityName", $$v)
                          },
                          expression: "formData.activityName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "适用分销客户",
                        prop: "applyCustomerType",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.lockCustomerAndTime },
                          on: { change: _vm.onApplyCustomerTypeChange },
                          model: {
                            value: _vm.formData.applyCustomerType,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "applyCustomerType", $$v)
                            },
                            expression: "formData.applyCustomerType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("全部"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("部分"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.formData.applyCustomerType === 1,
                          expression: "formData.applyCustomerType === 1",
                        },
                      ],
                      attrs: {
                        label: "",
                        prop: "customerIds",
                        required: _vm.formData.applyCustomerType === 1,
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "customer-select",
                          attrs: {
                            multiple: "",
                            filterable: "",
                            remote: "",
                            clearable: "",
                            disabled: _vm.lockCustomerAndTime,
                            "remote-method": _vm.searchCustomerOptions,
                            loading: _vm.customerLoading,
                            placeholder: "请选择",
                          },
                          on: {
                            "visible-change": _vm.onCustomerSelectVisible,
                            change: function ($event) {
                              _vm.duplicateHint = false
                            },
                          },
                          model: {
                            value: _vm.formData.customerIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "customerIds", $$v)
                            },
                            expression: "formData.customerIds",
                          },
                        },
                        _vm._l(_vm.customerOptions, function (item) {
                          return _c("el-option", {
                            key: item.customerId,
                            attrs: {
                              label: item.appName,
                              value: item.customerId,
                            },
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _vm.duplicateHint
                        ? _c("div", { staticClass: "dup-hint" }, [
                            _vm._v("请重新选择！"),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "活动开始时间", prop: "startTime" } },
                    [
                      _c("el-date-picker", {
                        ref: "startTimePicker",
                        staticClass: "w-360",
                        attrs: {
                          value: _vm.formData.startTime,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          "default-time": _vm.startTimeDefaultTime,
                          "default-value": _vm.startTimeDefaultValue,
                          placeholder: "请选择",
                          disabled: _vm.lockCustomerAndTime,
                          "popper-class": "lucky-wheel-datetime-hide-now",
                          "picker-options": _vm.isView
                            ? {}
                            : _vm.timePickerOptions,
                        },
                        on: {
                          focus: _vm.refreshStartTimeDefault,
                          input: _vm.onStartTimeInput,
                        },
                      }),
                      _vm._v(" "),
                      _vm.duplicateHint
                        ? _c("div", { staticClass: "dup-hint" }, [
                            _vm._v("请重新选择！"),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "活动结束时间", prop: "endTime" } },
                    [
                      _c("el-date-picker", {
                        ref: "endTimePicker",
                        staticClass: "w-360",
                        attrs: {
                          value: _vm.formData.endTime,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          "default-time": "23:59:59",
                          "default-value": _vm.endTimeDefaultValue,
                          placeholder: "请选择",
                          disabled: _vm.lockCustomerAndTime,
                          "popper-class": "lucky-wheel-datetime-hide-now",
                          "picker-options": _vm.isView
                            ? {}
                            : _vm.timePickerOptions,
                        },
                        on: {
                          focus: _vm.refreshEndTimeDefault,
                          input: _vm.onEndTimeInput,
                        },
                      }),
                      _vm._v(" "),
                      _vm.duplicateHint
                        ? _c("div", { staticClass: "dup-hint" }, [
                            _vm._v("请重新选择！"),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === 1,
                      expression: "currentStep === 1",
                    },
                  ],
                  staticClass: "step-panel",
                },
                [
                  _c("div", { staticClass: "prize-section" }, [
                    _c("div", { staticClass: "prize-title" }, [
                      _vm._v("奖项配置"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "prize-table-wrap" },
                      [
                        _c(
                          "el-table",
                          {
                            ref: "prizeTable",
                            staticClass: "prize-table",
                            attrs: {
                              data: _vm.formData.prizes,
                              "row-key": "_rowKey",
                              border: "",
                              size: "mini",
                              "highlight-current-row": "",
                              "header-cell-style": {
                                fontWeight: "bold",
                                background: "#f5f7fa",
                                color: "#606266",
                              },
                            },
                          },
                          [
                            !_vm.isView
                              ? _c("el-table-column", {
                                  attrs: {
                                    label: "排序",
                                    width: "56",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-rank prize-drag-handle",
                                              attrs: {
                                                title:
                                                  "拖动调整第" +
                                                  (scope.$index + 1) +
                                                  "格顺序",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3648558096
                                  ),
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "格子",
                                width: "76",
                                align: "center",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "第" + _vm._s(scope.$index + 1) + "格"
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "奖项类型", width: "128" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cell-field",
                                          class: {
                                            "is-invalid": _vm.prizeFieldError(
                                              scope.row,
                                              "prizeType"
                                            ),
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticClass: "cell-control",
                                              attrs: { placeholder: "请选择" },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.onPrizeTypeChange(
                                                    scope.row
                                                  )
                                                },
                                              },
                                              model: {
                                                value: scope.row.prizeType,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "prizeType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.prizeType",
                                              },
                                            },
                                            _vm._l(
                                              _vm.prizeTypeOptions,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.prizeFieldError(
                                            scope.row,
                                            "prizeType"
                                          )
                                            ? _c(
                                                "div",
                                                { staticClass: "cell-error" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.prizeFieldError(
                                                        scope.row,
                                                        "prizeType"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "图标",
                                width: "108",
                                align: "center",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("div", { staticClass: "icon-cell" }, [
                                        scope.row.icon
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "icon-preview",
                                                class: {
                                                  "is-invalid":
                                                    _vm.prizeFieldError(
                                                      scope.row,
                                                      "icon"
                                                    ),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.uploadPrizeIcon(
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: scope.row.icon,
                                                    alt: "",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                !_vm.isView
                                                  ? _c("i", {
                                                      staticClass:
                                                        "el-icon-close icon-remove",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.clearPrizeIcon(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: "icon-upload",
                                                class: {
                                                  "is-invalid":
                                                    _vm.prizeFieldError(
                                                      scope.row,
                                                      "icon"
                                                    ),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.uploadPrizeIcon(
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-plus",
                                                }),
                                              ]
                                            ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "icon-limit" },
                                          [_vm._v("限制大小200kb")]
                                        ),
                                        _vm._v(" "),
                                        _vm.prizeFieldError(scope.row, "icon")
                                          ? _c(
                                              "div",
                                              { staticClass: "cell-error" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.prizeFieldError(
                                                      scope.row,
                                                      "icon"
                                                    )
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "奖项内容", "min-width": "220" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cell-field",
                                          class: {
                                            "is-invalid": _vm.prizeFieldError(
                                              scope.row,
                                              "content"
                                            ),
                                          },
                                        },
                                        [
                                          _vm.isCouponPrize(scope.row.prizeType)
                                            ? _c(
                                                "el-select",
                                                {
                                                  staticClass: "cell-control",
                                                  attrs: {
                                                    filterable: "",
                                                    clearable: "",
                                                    placeholder: "请选择",
                                                    loading:
                                                      _vm.couponListLoading,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.onCouponChange(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: scope.row.couponId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "couponId",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.couponId",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.couponOptionsFor(
                                                    scope.row
                                                  ),
                                                  function (item) {
                                                    return _c("el-option", {
                                                      key: item.id,
                                                      attrs: {
                                                        label: item.name,
                                                        value: item.id,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              )
                                            : scope.row.prizeType === 3
                                            ? _c(
                                                "div",
                                                { staticClass: "addon-field" },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      maxlength: "8",
                                                      placeholder: "请输入",
                                                    },
                                                    on: {
                                                      input: function (v) {
                                                        return _vm.onPointsInput(
                                                          scope.row,
                                                          v
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: scope.row.points,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "points",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.points",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "addon-text",
                                                    },
                                                    [_vm._v("积分")]
                                                  ),
                                                ],
                                                1
                                              )
                                            : scope.row.prizeType === 4
                                            ? _c(
                                                "el-select",
                                                {
                                                  staticClass: "cell-control",
                                                  attrs: {
                                                    filterable: "",
                                                    remote: "",
                                                    clearable: "",
                                                    placeholder: "请输入skuid",
                                                    "remote-method": function (
                                                      kw
                                                    ) {
                                                      return _vm.searchSkuOptions(
                                                        scope.row,
                                                        kw
                                                      )
                                                    },
                                                    loading:
                                                      scope.row.skuLoading,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.onSkuChange(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: scope.row.skuId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "skuId",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.skuId",
                                                  },
                                                },
                                                _vm._l(
                                                  scope.row.skuOptions,
                                                  function (item) {
                                                    return _c("el-option", {
                                                      key: item.skuId,
                                                      attrs: {
                                                        label:
                                                          _vm.skuOptionLabel(
                                                            item
                                                          ),
                                                        value: item.skuId,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              )
                                            : scope.row.prizeType === 6
                                            ? _c(
                                                "div",
                                                { staticClass: "thanks-text" },
                                                [_vm._v("抽奖次数 +1")]
                                              )
                                            : _c(
                                                "div",
                                                { staticClass: "thanks-text" },
                                                [_vm._v("无")]
                                              ),
                                          _vm._v(" "),
                                          _vm.prizeFieldError(
                                            scope.row,
                                            "content"
                                          )
                                            ? _c(
                                                "div",
                                                { staticClass: "cell-error" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.prizeFieldError(
                                                        scope.row,
                                                        "content"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "商品上限", width: "110" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm.showStockFields(scope.row.prizeType)
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "cell-field",
                                              class: {
                                                "is-invalid":
                                                  _vm.prizeFieldError(
                                                    scope.row,
                                                    "productLimit"
                                                  ),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticClass: "cell-control",
                                                attrs: {
                                                  placeholder: "请输入",
                                                  disabled:
                                                    !_vm.canEditProductLimit(
                                                      scope.row
                                                    ),
                                                },
                                                on: {
                                                  input: function (v) {
                                                    return _vm.onProductLimitInput(
                                                      scope.row,
                                                      v
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: scope.row.productLimit,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "productLimit",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.productLimit",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _vm.prizeFieldError(
                                                scope.row,
                                                "productLimit"
                                              )
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "cell-error",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.prizeFieldError(
                                                            scope.row,
                                                            "productLimit"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "span",
                                            { staticClass: "empty-cell" },
                                            [_vm._v("—")]
                                          ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "库存",
                                width: "110",
                                align: "center",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          class: _vm.hasStockValue(scope.row)
                                            ? "stock-text"
                                            : "empty-cell",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.stockDisplay(scope.row))
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "前端展示文案",
                                "min-width": "168",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cell-field",
                                          class: {
                                            "is-invalid": _vm.prizeFieldError(
                                              scope.row,
                                              "displayText"
                                            ),
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "cell-control",
                                            attrs: {
                                              maxlength: "10",
                                              "show-word-limit": "",
                                              placeholder: "请输入",
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.clearPrizeError(
                                                  scope.row,
                                                  "displayText"
                                                )
                                              },
                                            },
                                            model: {
                                              value: scope.row.displayText,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "displayText",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.displayText",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _vm.prizeFieldError(
                                            scope.row,
                                            "displayText"
                                          )
                                            ? _c(
                                                "div",
                                                { staticClass: "cell-error" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.prizeFieldError(
                                                        scope.row,
                                                        "displayText"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "格子背景色",
                                width: "96",
                                align: "center",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-color-picker", {
                                        attrs: {
                                          "show-alpha": "",
                                          size: "mini",
                                        },
                                        model: {
                                          value: scope.row.bgColor,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "bgColor", $$v)
                                          },
                                          expression: "scope.row.bgColor",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "中奖概率", width: "140" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "cell-field",
                                          class: {
                                            "is-invalid": _vm.prizeFieldError(
                                              scope.row,
                                              "probability"
                                            ),
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "addon-field" },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  placeholder:
                                                    _vm.isThanksPrize(
                                                      scope.row.prizeType
                                                    )
                                                      ? "1-100"
                                                      : "0-100",
                                                },
                                                on: {
                                                  input: function (v) {
                                                    return _vm.onProbabilityInput(
                                                      scope.row,
                                                      v
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: scope.row.probability,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "probability",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.probability",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "addon-text" },
                                                [_vm._v("%")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.prizeFieldError(
                                            scope.row,
                                            "probability"
                                          )
                                            ? _c(
                                                "div",
                                                { staticClass: "cell-error" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.prizeFieldError(
                                                        scope.row,
                                                        "probability"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            !_vm.isView
                              ? _c("el-table-column", {
                                  attrs: {
                                    label: "操作",
                                    width: "64",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            !_vm.isThanksPrize(
                                              scope.row.prizeType
                                            )
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    staticClass: "danger-text",
                                                    attrs: {
                                                      type: "text",
                                                      size: "mini",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.removePrize(
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                删除\n              "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3416431802
                                  ),
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "prize-footer" },
                      [
                        !_vm.isView
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "text",
                                  icon: "el-icon-plus",
                                  disabled: _vm.formData.prizes.length >= 10,
                                },
                                on: { click: _vm.addPrize },
                              },
                              [_vm._v("\n            新增奖项\n          ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "prob-total",
                            class: { "is-error": _vm.probabilityTotal !== 100 },
                          },
                          [
                            _vm._v(
                              "概率合计: " + _vm._s(_vm.probabilityTotal) + "%"
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "footer-actions",
              class: { "is-step-two": _vm.currentStep === 1 },
            },
            [
              _vm.currentStep === 1
                ? _c(
                    "el-button",
                    { attrs: { size: "small" }, on: { click: _vm.prevStep } },
                    [_vm._v("上一步")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "footer-right" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.handleCancel },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _vm.currentStep === 0
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.nextStep },
                        },
                        [_vm._v("下一步")]
                      )
                    : !_vm.isView
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "has-permi",
                              rawName: "v-has-permi",
                              value: _vm.savePerms,
                              expression: "savePerms",
                            },
                          ],
                          attrs: {
                            type: "primary",
                            size: "small",
                            loading: _vm.submitLoading,
                          },
                          on: { click: _vm.handleSave },
                        },
                        [_vm._v("\n          保存\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }